import React from "react";
import ReactDOM from "react-dom/client";

// Import third-party CSS in consistent order to prevent chunk ordering conflicts
import "leaflet/dist/leaflet.css";
import "swiper/swiper-bundle.css";

import "./index.css";
import App from "./App";
import Context from "./Context/Context";
import { Toaster } from "react-hot-toast";

// Defer AOS initialization to after first paint
const initAOS = async () => {
  const AOS = (await import("aos")).default;
  await import("aos/dist/aos.css");
  AOS.init({
    once: true, // Only animate once for better performance
    duration: 600,
    easing: "ease-out",
  });
};

// Initialize AOS after page is interactive
if ("requestIdleCallback" in window) {
  requestIdleCallback(() => initAOS());
} else {
  setTimeout(initAOS, 100);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Context>
      <App />
      <Toaster />
    </Context>
  </React.StrictMode>,
);
